import { render, staticRenderFns } from "./ImportUsersTab.vue?vue&type=template&id=508c2c54&scoped=true&"
import script from "./ImportUsersTab.vue?vue&type=script&lang=js&"
export * from "./ImportUsersTab.vue?vue&type=script&lang=js&"
import style0 from "./ImportUsersTab.vue?vue&type=style&index=0&id=508c2c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c2c54",
  null
  
)

export default component.exports